import { Component, OnInit } from '@angular/core';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { FirmwareDetails } from '../types/firmware-details';
import { FirmwareSet } from '../types/firmware-set';
import { SubMenuOption } from '../types/submenu-option';

@Component({
  selector: 'firmwares',
  template: `<div id="content">
  <sub-menu [options]="subMenu"></sub-menu>
  <ul class="firmwares">
    <li>
      <span class="version">Version</span>
      <span class="name">Name</span>
      <span class="bool center">Stable</span>
      <span class="date">Created</span>
      <span class="date">Set</span>
    </li>

    <li *ngFor="let firmware of firmwares" class="firmware">
      <div (click)="toggle(firmware.uid)">
        <span class="version">{{ firmware.major }}.{{ firmware.minor }}.{{ firmware.patch }}</span>
        <span class="name">{{ firmware.name }}</span>
        <span class="bool center">{{ firmware.stable | boolean }}</span>
        <span class="date">{{ firmware.created | godate}}</span>
        <span class="fwsetid">{{ firmware.fwsetid}}</span>
      </div>
      <div *ngIf="firmware.uid === expanded">
        <span class="uri">{{ firmware.uri }}</span><br>
        <span class="hashtype">{{ firmware.hashtype }}</span>
        <span class="hash">{{ firmware.hash }}</span>
        <span class="number">{{ firmware.size }}</span> bytes
      </div>
      <firmware-edit *ngIf="firmware.uid === expanded"
                     [inFirmware]="firmware"
                     [inFirmwareSets]="firmwareSets"
                     (firmware_saved)="onFirmwareSaved($event)"
                     (minimised)="toggle(firmware.uid)"></firmware-edit>
    </li>

    <li>
      <span class="number center"> &nbsp; </span>
    </li>
  </ul>
</div>
<div id="error" class="error" *ngIf="!!errorMessage">{{errorMessage}}</div>
`,
  styleUrls: ['./firmwares.component.css'],
  providers: [HubService]
})

export class FirmwaresComponent implements OnInit {
  errorMessage: string;
  firmwares: FirmwareDetails[];
  firmwareSets: FirmwareSet[];
  subMenu: SubMenuOption[];
  private expanded: number;

  constructor(
    private hubService: HubService
  ) {
    this.subMenu = [
      { route: '/firmwaresets', title: 'Firmware Sets' },
      { route: '/firmwares', title: 'Firmwares' },
    ];
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.refresh();
    AppComponent.SetTitle('All Firmwares');
  }

  refresh(): void {
    try {
      this.hubService.getFirmwareDetails().subscribe(
        firmwares => this.firmwares = firmwares,
        error => this.errorMessage = <any>error,
      );
    } catch (e) {
      console.log('Meh: ' + e);
    }
    try {
      this.hubService.getFirmwareSets().subscribe(
        firmwareSets => this.firmwareSets = firmwareSets,
        error => this.errorMessage = <any>error,
      );
    } catch (e) {
      console.log('Meh: ' + e);
    }
  }

  onFirmwareSaved(ev: Event): void {
    this.refresh();
  }

  toggle(uid: number): void {
    if (this.expanded === uid) {
      this.expanded = 0;
    } else {
      this.expanded = uid;
    }
    console.log('Expansion set to ' + this.expanded);
  }
}
